var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.0372 0 0 4.0372 0 9C0 13.9628 4.0372 18 9 18C13.9628 18 18 13.9628 18 9C18 4.0372 13.9628 0 9 0ZM13.5615 7.09277L8.68648 11.9677C8.54022 12.1139 8.34824 12.1875 8.15625 12.1875C7.96426 12.1875 7.77228 12.1139 7.62602 11.9677L5.18857 9.53023C4.89523 9.23703 4.89523 8.76297 5.18857 8.46977C5.48177 8.17644 5.95569 8.17644 6.24902 8.46977L8.15625 10.377L12.5011 6.03232C12.7943 5.73898 13.2682 5.73898 13.5615 6.03232C13.8547 6.32552 13.8547 6.79944 13.5615 7.09277Z",
    fill: "#4EAEA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.ba3e2637.svg";
export { ForwardRef as ReactComponent };